<cap-input-switch [formControl]="formControl"
               [style]="to.style || null"
               [styleClass]="to.styleClass || null"
               [disabled]="to.disabled || false"
               [readonly]="to.readonly || false"
               [formlyAttributes]="field">
</cap-input-switch>
